import { OpeningApprovalsService } from 'api-clients/monolith';
import { useCallback } from 'react';

import { useApiService } from './useApiService';

export function useOpeningApproval(openingId: string) {
  const fetchOpeningApproval = useCallback(
    () =>
      OpeningApprovalsService.getInternalApiOpeningApprovalApprovals(
        'Any Status',
        undefined,
        undefined,
        undefined,
        openingId,
      ),
    [openingId],
  );

  const { result, ...rest } = useApiService(fetchOpeningApproval);

  const openingApproval =
    result.status === 'ready' ? result.data.opening_approvals?.[0] : undefined;

  return { openingApproval, ...rest };
}
